import { useParams } from "react-router-dom";
import { FormsInstancePage } from "./FormsInstancePage";

const Forms = () => {
	const { formId } = useParams();

	return <FormsInstancePage formId={formId} />;
};

export default Forms;
